import { post, remove } from '../Services/http';
import { catchError } from './Error.action';
import { receive } from './Cart.action';
import { translate } from '../Services/translation';
import { show as showNotification } from './Notification.action';

export const WISHLIST_CHANGE_QUANTITY = 'WISHLIST_CHANGE_QUANTITY';
export const WISHLIST_UPDATE = 'WISHLIST_UPDATE';
export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';
export const WISHLIST_LOAD_ERROR = 'WISHLIST_LOAD_ERROR';

export const changeQuantity = (articleNumber, quantity) => dispatch => {
  dispatch({
    type: WISHLIST_CHANGE_QUANTITY,
    articleNumber,
    quantity,
  });
};

export const removeFromWishList = articleNumber => dispatch => {
  return remove('/api/wishlist/remove', { articleNumber })
    .then(response => response.json())
    .then(items => {
      dispatch({
        type: WISHLIST_UPDATE,
        items: items,
        payload: {
          success: true,
          message: `${articleNumber} ${translate('wishlist.itemwasremoved')}`,
        },
      });
    })
    .catch(ex => {
      dispatch({
        type: WISHLIST_UPDATE,
        payload: {
          success: false,
          message: translate('wishlist.error'),
        },
      });
    });
};

export const updateWishList = () => (dispatch, getState) => {
  return post('/api/wishlist/update', getState().wishlist)
    .then(response => response.json())
    .then(items => {
      dispatch({
        type: WISHLIST_UPDATE,
        items: items,
        payload: {
          success: true,
          message: translate('wishlist.update.success'),
        },
      });
    })
    .catch(ex => {
      dispatch({
        type: WISHLIST_UPDATE,
        payload: {
          success: false,
          message: translate('wishlist.error'),
        },
      });
    });
};

export const addToCart = () => dispatch => {
  return post('/api/wishlist/addtocart')
    .then(response => response.json())
    .then(cart => {
      dispatch(receive(cart));
      dispatch({
        type: WISHLIST_ADD_TO_CART,
        payload: {
          success: true,
          message: translate('wishlist.addtocart.success'),
        },
      });
    })
    .catch(ex => {
      dispatch({
        type: WISHLIST_ADD_TO_CART,
        payload: {
          success: false,
          message: translate('wishlist.error'),
        },
      });
    });
};

export const add = ({
  articleNumber,
  quantity = 1,
  nodeIdToShowNotification = null,
  notificationMessage = null,
  hash = '',
}) => {
  return dispatch => {
    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
      return;
    }

    return post('/api/wishlist/add', {
      articleNumber,
      quantity: parseInt(quantity),
    })
      .then(response => response.json())
      .then(result => {
        nodeIdToShowNotification &&
          dispatch(
            showNotification(
              nodeIdToShowNotification,
              notificationMessage,
              hash,
            ),
          );
      })
      .catch(ex =>
        dispatch(
          catchError(ex, error => ({
            type: WISHLIST_LOAD_ERROR,
            payload: {
              error,
            },
          })),
        ),
      );
  };
};
